export default "__VITE_ASSET__sNUGeDHc__"